import React from "react";
import HomeSideNavBar from "../HomeSideNavBar";
import Header from "../Header";
import ApiDataProvider from "../ApiDataContext";
import AssetList from "../../features/assets/AssetList";

/**
 * Assets page shell. Replaces the 4-tab List/Register/Allocate/Passcode
 * layout with a single list-centric page. Create, edit, and assign all
 * happen in slide-overs opened from the page header CTA or row kebab —
 * preserving every permission (assets_registerAsset / assets_allocation /
 * assets_passcode) inside the new AssetList component.
 */
function Assets() {
  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />
          <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-surface-muted overflow-y-auto">
            <AssetList />
          </main>
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default Assets;
